import React from 'react';
import { createFromIconfontCN } from '@ant-design/icons';
import classNames from 'classnames';
export { ICON_CATEGORIES } from './config';
import { parseLegacyNames } from './util';
export { iconNameToTypeProps } from './util';
import { globalConfig } from '../config-provider';
const LegacyIconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2545178_nqjwahm5zge.js',
    extraCommonProps: { className: globalConfig().getIconPrefixCls() }
});
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/a/font_3190313_65ry63itsuf.js',
    extraCommonProps: { className: globalConfig().getIconPrefixCls() }
});
export const Icon = (props) => {
    // const { prefixCls = 'b-design-icon' } = React.useContext(IconContext);
    const prefixCls = 'b-design-icon';
    const { className: customizeClassName, size, type: customizeType, ...otherProps } = props;
    const type = parseLegacyNames(customizeType);
    const className = classNames('b-design-icon', {
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-md`]: size === 'middle',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-xl`]: size === 'xl',
        [`${prefixCls}-xs`]: size === 'xs'
    }, customizeClassName);
    if (type) {
        // @ts-ignore
        return React.createElement(LegacyIconFont, { className: className, type: type, ...otherProps });
    }
    else {
        // @ts-ignore
        return React.createElement(IconFont, { className: className, type: customizeType, ...otherProps });
    }
};
export default Icon;
// export default withConfigProvider(Icon);
